import styled from 'styled-components';

const CardContent = styled.div`
  * {
    width: 100%;
  }
`;

export default CardContent;
